// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3HqKf","label":"Completed_label__3qNRM"};